"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intToByteArray = exports.decode = exports.encode = exports.concat = exports.append = exports.join = void 0;
/**
 * Join a list of byte-arrays using the specified separator, analogous to Array.join
 * @param array The input array
 * @param separator The separator byte
 */
function join(array, separator) {
    // Get everything except the last element so we don't add a separator after the end
    const head = [...array.slice(0, -1)];
    const tail = [...array.slice(-1)];
    // Map-reduce the head and the tail to a flattened list of bytes with the separator appended
    return concat(...[...head.map((bytes) => append(bytes, separator)), ...tail]);
}
exports.join = join;
/**
 * Add a single byte to the end of the byte-array
 * @param bytes
 * @param byte
 */
function append(bytes, byte) {
    return new Uint8Array([...bytes, byte]);
}
exports.append = append;
/**
 * Concatenate byte-arrays
 * @param arrays
 */
function concat(...arrays) {
    return new Uint8Array(arrays.reduce((buffer, bytes) => [...buffer, ...bytes], []));
}
exports.concat = concat;
/**
 * Convert a string to byte-array
 * @param str
 */
function encode(str) {
    return new Uint8Array(Buffer.from(str, 'latin1'));
}
exports.encode = encode;
/**
 * Convert a byte-array to a "binary string" string
 * @param bytes
 */
function decode(bytes) {
    return Buffer.from(bytes).toString('latin1');
}
exports.decode = decode;
/**
 * Convert a 32-bit integer or number into an n-byte array, possibly losing digits and/or precision (little-endian)
 * @param num The number to convert
 * @param length The length of the byte-array to generate
 * @param padding The number to pad remaining bytes
 * @param padLeft Whether to pad from the left or from the right
 */
function intToByteArray(num, length, padding = 0x0, padLeft = true) {
    // Get the actual size (in bytes) of the number
    const maxBytes = (((num - 1) / 0xff) | 0) + 1;
    // Determine the minimum amount of bytes we need to convert
    const convertBytes = Math.min(maxBytes, length);
    // Determine the padding bytes
    const paddingBytes = new Uint8Array(length - convertBytes).fill(padding);
    // Start off with an array of the minimum length
    const array = new Uint8Array(convertBytes)
        .map((v, i) => {
        // 1. Shift the number to the right to remove the n most significant bits: 0x227711 >> 8 = 0x2277
        // 2. Mask the number to get the byte: 0x2277 & 0xff = 0x77
        return (num >> (8 * i)) & 0xff;
    })
        // Reverse the array to get the right order
        .reverse();
    // Concat on the specified side
    if (padLeft)
        return concat(paddingBytes, array);
    return concat(array, paddingBytes);
}
exports.intToByteArray = intToByteArray;
//# sourceMappingURL=byte-tools.js.map